
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("fmcAt"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("fmcAt", function(module, exports) {

let $b2e2acae6e919dd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2e2acae6e919dd2$var$load("h3ABO"),
    $b2e2acae6e919dd2$var$load("9hYRW"),
    $b2e2acae6e919dd2$var$load("kpm7S"),
    $b2e2acae6e919dd2$var$load("kc8tx"),
    $b2e2acae6e919dd2$var$load("2YffH"),
    $b2e2acae6e919dd2$var$load("g7ggm"),
    $b2e2acae6e919dd2$var$load("6mHrv"),
    $b2e2acae6e919dd2$var$load("awWN9"),
    $b2e2acae6e919dd2$var$load("9CYct"),
    $b2e2acae6e919dd2$var$load("dvaCT"),
    $b2e2acae6e919dd2$var$load("dLE56"),
    $b2e2acae6e919dd2$var$load("hZtKG"),
    $b2e2acae6e919dd2$var$load("dkqvW"),
    $b2e2acae6e919dd2$var$load("lVO3w"),
    $b2e2acae6e919dd2$var$load("hyzoX"),
    $b2e2acae6e919dd2$var$load("h9Ed7"),
    $b2e2acae6e919dd2$var$load("eBRUf"),
    $b2e2acae6e919dd2$var$load("kbRvk"),
    $b2e2acae6e919dd2$var$load("tKhaz"),
    $b2e2acae6e919dd2$var$load("hwT9D"),
    $b2e2acae6e919dd2$var$load("j4Bpe"),
    $b2e2acae6e919dd2$var$load("cD6Zr"),
    $b2e2acae6e919dd2$var$load("k3jER"),
    $b2e2acae6e919dd2$var$load("9wzNh"),
    $b2e2acae6e919dd2$var$load("8YSo7"),
    $b2e2acae6e919dd2$var$load("9ldRJ"),
    $b2e2acae6e919dd2$var$load("50ame"),
    $b2e2acae6e919dd2$var$load("7do1E"),
    $b2e2acae6e919dd2$var$load("77dkW"),
    $b2e2acae6e919dd2$var$load("1MlIV"),
    $b2e2acae6e919dd2$var$load("6iz6l"),
    $b2e2acae6e919dd2$var$load("4SCW2"),
    $b2e2acae6e919dd2$var$load("aXHNO"),
    $b2e2acae6e919dd2$var$load("kmvek"),
    $b2e2acae6e919dd2$var$load("Wowvf"),
    $b2e2acae6e919dd2$var$load("421lv"),
    $b2e2acae6e919dd2$var$load("dek7I"),
    $b2e2acae6e919dd2$var$load("3SmkN"),
    $b2e2acae6e919dd2$var$load("dYtBN"),
    $b2e2acae6e919dd2$var$load("kNV5Y"),
    $b2e2acae6e919dd2$var$load("6wr18"),
    $b2e2acae6e919dd2$var$load("kjZZD"),
    $b2e2acae6e919dd2$var$load("7cDV0"),
    $b2e2acae6e919dd2$var$load("ijD5W"),
    $b2e2acae6e919dd2$var$load("3JSgG"),
    $b2e2acae6e919dd2$var$load("37ldp"),
    $b2e2acae6e919dd2$var$load("ffEVr"),
    $b2e2acae6e919dd2$var$load("9AXkC"),
    $b2e2acae6e919dd2$var$load("28arV"),
    $b2e2acae6e919dd2$var$load("hhss7"),
    $b2e2acae6e919dd2$var$load("hvsDR"),
    $b2e2acae6e919dd2$var$load("9t4BV"),
    $b2e2acae6e919dd2$var$load("f1Pmi"),
    $b2e2acae6e919dd2$var$load("dP7ao"),
    $b2e2acae6e919dd2$var$load("hogcU"),
    $b2e2acae6e919dd2$var$load("5vfHd"),
    $b2e2acae6e919dd2$var$load("2Stk7"),
    $b2e2acae6e919dd2$var$load("7EorR"),
    $b2e2acae6e919dd2$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.76291f88.js.map
